import React from "react"
import { graphql } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links";
import Layout from "../layout/layout"
import SEO from "../layout/seo"

import './sessions.scss'
import { Link } from 'gatsby-plugin-modal-routing-3'
import imgHeroLogo from "../images/ignite-summit-icon-turquoise.svg"

export default ({ data, pageContext }) => {
    const spkr = data.allSessionizeSpeakersJson.edges[0].node;

    const { session } = pageContext;

    return (
        <Layout attr="session">
            <SEO title={session.title} />
            <div className="innerHeader">
                <div className="container">
                    <img src={imgHeroLogo} width={`57px`} height={`40px`} />
                    <h1>Ignite summit <span className="turquoise">schedule</span></h1>
                </div>
            </div>
            <div className="container" style={{
                paddingTop: `2rem`
            }}>
                
                <AnchorLink to={`/schedule#timeline`} className="anchor turquoise"><span>←</span> Full schedule</AnchorLink>
                
                <div className="session-wrapper"  >
                    <h2>{session.title}</h2>

                    <p className="description">{session.description}</p>
                    
                    <div class="session-speaker-wrapper">
                        {data.allSessionizeSpeakersJson.edges.map(spkr => (
                        <div className="session-speaker session-speaker-page" key={spkr.node.fullName.toString()}>
                            <div className="img-wrapper">
                                {spkr.node.profilePicture && <img alt={spkr.node.fullName} src={spkr.node.profilePicture} />}
                                {!spkr.node.profilePicture && <div className="img-placeholder" style={{height: `30px`}}></div>}
                                <h3>{spkr.node.fullName}</h3>
                                <div className="tagline">{spkr.node.tagLine}</div>
                            </div>
                            <div className="txt-wrapper">
                                <p>{spkr.node.bio}</p>
                            </div>
                        </div>
                        ))}
                    </div>
                
                
                    <div className="buttons">
                        <Link
                            to="/register"
                            className="button past"
                            asModal>
                                watch now →
                        </Link>
                    </div>
                </div>
                
            </div>
        </Layout>
    )
}

export const query = graphql`
query($speakerId: [String!]!) {
    allSessionizeSpeakersJson(filter: {id: {in: $speakerId}}) {
      edges {
        node {
          id
          bio
          fullName
          tagLine
          profilePicture
        }
      }
    }
  }  
`

